<template>
  <div class="comment-actions-bar">
    <div class="comment-actions">
      <div class="react">
        <icon-button
          icon="add_reaction"
          classes="-ico-only -no-container"
          aria-label="Add Like Reaction"
          :aria-expanded="likeReactFormOpen.toString()"
          :aria-controls="`like-react-form-${commentId}`"
          @click-action="$emit('react-form')"
        />
      </div>
      <div class="reply">
        <icon-button
          icon="reply"
          classes="-ico-only -no-container"
          aria-label="Reply"
          :aria-expanded="commentReplyFormOpen.toString()"
          :aria-controls="`comment-form-${commentId}`"
          @click-action="$emit('comment-reply-form', { parentId })"
        />
      </div>
    </div>

    <div class="comment-actions">
      <comment-actions-menu
        v-if="ownedByUser"
        :comment-id="commentId"
        @edit-comment="$emit('edit-comment')"
        @delete-comment="$emit('delete-comment')"
      />

      <div v-if="!ownedByUser" class="flag" :class="{ '-flagged': isFlagged }">
        <icon-button
          icon="flag"
          classes="-ico-only -no-container"
          aria-label="Flag"
          :icons-outlined="!isFlagged"
          @click-action="toggleFlagModal"
        />
      </div>

      <pay-forward-action-menu
        v-if="!ownedByUser && showPayForward"
        entity-type="comment"
        :entity-id="commentId"
        :gift-user-id="commentUserId"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useUserAuthStore } from '@/stores/user-auth'
import { useModalsStore } from '@/stores/modals'
import IconButton from '@/components/buttons/icon-button.vue'
import CommentActionsMenu from './comment-actions-menu.vue'
import PayForwardActionMenu from '@/components/cart/pay-forward-action-menu.vue'

/** PROPS */
withDefaults(
  defineProps<{
    commentUserId: number
    commentId: number
    parentId: number
    ownedByUser: boolean
    showPayForward: boolean
    likedByUser?: boolean
    isFlagged?: boolean
    likeReactFormOpen?: boolean
    commentReplyFormOpen?: boolean
  }>(),
  {
    likedByUser: false,
    isFlagged: false,
    likeReactFormOpen: false,
    commentReplyFormOpen: false,
  },
)

/** EMITS */
const emit = defineEmits([
  'react-form',
  'comment-reply-form',
  'edit-comment',
  'delete-comment',
  'flag-modal',
])

/** STATE */
const userAuthStore = useUserAuthStore()
const modalsStore = useModalsStore()

/** COMPUTED */

/** METHODS */
function toggleFlagModal() {
  if (!userAuthStore.user.isLoggedIn) {
    modalsStore.showLoginModal()
    return
  }

  emit('flag-modal')
}
</script>
